<template>
  <div>
    <wysiwyg-editor
      :model="note.message"
      @change="val => note.message = val"
      :light="true"
      :tooltip-position="'top'"
      :from-quickview="true"
      class="is-padding-xsmall wysiwygEditor--noteLeads"></wysiwyg-editor>
    <div
      v-if="source && source.type === 'optionComment'"
      class="is-padding-bottom-xsmall is-padding-left-xsmall">
      <span class="is-size-6 has-text-weight-semibold">Date mise à jour option : </span>
      <span class="is-size-6 has-text-weight-normal">{{ currentDate }}</span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'NoteCreate',
  props: {
    source: {
      type: Object
    }
  },
  data () {
    return {
      note: {
        message: null
      }
    }
  },
  computed: {
    currentDate () {
      if (this.source && this.source.updated_on) {
        return moment(this.source.updated_on).format('DD/MM/YYYY HH:mm')
      }
      return moment().format('DD/MM/YYYY HH:mm')
    }
  },
  created () {
    if (this.source) this.note = this.source
    this.openWysiwyg()
  },
  methods: {
    submitQuickview () {
      this.$emit('submitQuickview', { note: this.note })
    },
    openWysiwyg () {
      this.$nextTick(() => {
        let wysiElem
        if (this.source) {
          let selection = document.getSelection()
          let range = document.createRange()
          let contenteditable = document.querySelector('div[contenteditable="true"]')

          if (contenteditable.lastChild.nodeType === 3) {
            range.setStart(contenteditable.lastChild, contenteditable.lastChild.length)
          } else {
            range.setStart(contenteditable, contenteditable.childNodes.length)
          }
          selection.removeAllRanges()
          selection.addRange(range)
        } else {
          wysiElem = document.getElementsByClassName('ql-editor ql-blank')
          wysiElem = wysiElem[0]
          wysiElem.setAttribute('contenteditable', 'true')
          wysiElem.focus()
        }
      })
    }
  }
}
</script>

<style lang="sass">
.quickview
  .wysiwygEditor--noteLeads
    .ql-container
      .ql-editor
        // HB :
        // Fix manuel de la hauteur du champs de note
        // Tellement particulier quand me fait manuellement en css
        // On pourrait aussi le faire en JS mais lancer des calculs de hauteurs ne me semble pas pertinant
        // L'imbrication des sélecteurs est importante pour être sur de ne pas toucher l'élément sur d'autre page.
        min-height: 250px
        height: 51vh
        height: calc(100vh - 83px - 55px - 10px - 36px - 10px - 82px - 35px)
        max-height: 80vh
      #emoji-palette
        top: unset !important
        bottom: 0
        left: 0 !important
        right: 0
        max-width: 100% !important
</style>
